import { createAction, props } from '@ngrx/store';

export const ACCOUNT_TEAMS = {
	USERS_LIST: {
		GET: createAction('[ACCOUNT_TEAMS] Get users list', props<any>()),
		SUCCESS: createAction('[ACCOUNT_TEAMS] Get users list success', props<any>()),
		FAILURE: createAction(
			'[ACCOUNT_TEAMS] Get users list failed',
			props<{ payload: { message: string } }>()
		),
	},

	INVITE_USERS: {
		OPEN_DIALOG: createAction('[ACCOUNT_TEAMS] open invite users dialog', props<any>()),
		SUCCESS: createAction('[ACCOUNT_TEAMS] invite users list success', props<any>()),
		CLOSE_DIALOG: createAction('[ACCOUNT_TEAMS] invite users dialog closed', props<any>()),
	},

	SET: {
		PAGE: createAction('[ACCOUNT_TEAMS] Set teams users page', props<any>()),
		PAGE_SIZE: createAction('[ACCOUNT_TEAMS] Set teams users page size', props<any>()),
		FILTER_LIST: createAction(
			'[ACCOUNT_TEAMS] set teams users filters list',
			props<{ filtersList: any[] }>()
		),
		SORT_LIST: createAction(
			'[ACCOUNT_TEAMS] set teams users sorts list',
			props<{ sortList: any[] }>()
		),
	},

	ACTIVATE_USER: {
		ACTIVATE: createAction('[ACCOUNT_TEAMS] Activate user', props<any>()),
		SUCCESS: createAction('[ACCOUNT_TEAMS] Activate user success', props<any>()),
		FAILURE: createAction('[ACCOUNT_TEAMS] Activate user failed', props<any>()),
	},

	DEACTIVATE_USER: {
		DEACTIVATE: createAction('[ACCOUNT_TEAMS] Deactivate user', props<any>()),
		SUCCESS: createAction('[ACCOUNT_TEAMS] Deactivate user success', props<any>()),
		FAILURE: createAction('[ACCOUNT_TEAMS] Deactivate user failed', props<any>()),
	},

	UPDATE_USER_ROLE: {
		UPDATE: createAction('[ACCOUNT_TEAMS] Update user role', props<any>()),
		SUCCESS: createAction('[ACCOUNT_TEAMS] Update user role success', props<any>()),
		FAILURE: createAction('[ACCOUNT_TEAMS] Update user role failed', props<any>()),
	},

	SET_EMAIL_RECIPIENT: {
		SET: createAction('[ACCOUNT_TEAMS] Set email recipient', props<any>()),
		SUCCESS: createAction('[ACCOUNT_TEAMS] Set email recipient success', props<any>()),
		FAILURE: createAction('[ACCOUNT_TEAMS] Set email recipient failed', props<any>()),
	},

	RESET_STATE: createAction('[ACCOUNT_TEAMS] Reset teams users state', props<any>()),
};
